'use client';

import React, { useState, useEffect } from 'react';
import { Chip } from '@unity/cloud-ui';

export const BaseSearchInputShortcut = () => {
  const [isMacPlatform, setIsMacPlatform] = useState<boolean | null>(null);

  useEffect(() => {
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    setIsMacPlatform(isMac);
  }, []);

  if (isMacPlatform === null) {
    return null;
  }

  return <Chip label={isMacPlatform ? '⌘ K' : 'Ctrl K'} squared />;
};
